import type { QueryStringInput } from '@hello-aria/query-string'
import { isNil } from 'lodash'
import type { RedirectionGateway } from '@/shared/models/redirectionModels'
import { type Page, toListQuery } from '@hello-aria/makalu-api-client'
import { makaluApi } from '@/shared/utils/makaluApiClient'
import { batchFetch } from '@/shared/utils/requestsUtils'
import { handleHttpError } from '@/shared/utils/queryUtils'

interface GetRedirectionsParams {
    companyId: string
    query?: QueryStringInput
    signal?: AbortSignal
}

export const listRedirections = batchFetch(async (params: GetRedirectionsParams): Promise<Page<RedirectionGateway>> => {
    try {
        return await makaluApi.listPage('/companies/{companyId}/redirections', {
            params: {
                path: { companyId: params.companyId },
                query: toListQuery({
                    ...params.query,
                    sorts: params.query?.sorts ?? [
                        {
                            path: 'createdAt',
                            direction: 'desc'
                        }
                    ]
                })
            },
            signal: params.signal
        })
    } catch (error) {
        return handleHttpError('listRedirections', error)
    }
})

export const getRedirection = async (
    companyId: string,
    redirectionId: string | undefined
): Promise<RedirectionGateway | undefined> => {
    if (isNil(redirectionId)) return

    try {
        return await makaluApi.GET('/companies/{companyId}/redirections/{redirectionId}', {
            params: { path: { companyId, redirectionId } }
        })
    } catch (error) {
        return handleHttpError('getRedirection', error)
    }
}
